import axios from "axios";
import { SETTINGS } from "../../Settings";

export const AppEntryDocRepository = {
  getAll: (appEntryId) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntryDocs/${appEntryId}`,
      method: "GET",
    });
  },

  saveSignedDoc: (bytes, appEntryId, selectedFile) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntryDocs/saveSignedDoc`,
      method: "POST",
      data: {
        bytes: bytes,
        appEntryId: appEntryId,
        selectedFile: selectedFile,
      },
    });
  },

  uploadNewApprovalRequest: (request) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntryDocs/uploadNewApprovalRequest`,
      method: "POST",
      data: request,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  getDocument: (appEntryId, fileName) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntryDocs/get/${appEntryId}/${fileName}`,
      method: "GET",
      responseType: "blob",
    });
  },

  getGeneratedDocs: (appEntryId) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntryDocs/generatedDocs/${appEntryId}`,
      method: "GET",
    });
  },

  getDecision: (docId) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntryDocs/decision/${docId}`,
      method: "GET",
      responseType: "blob",
    });
  },
};
